import { render } from "./ChannelPerformanceSection.vue?vue&type=template&id=771f8d8f"
import script from "./ChannelPerformanceSection.vue?vue&type=script&lang=js"
export * from "./ChannelPerformanceSection.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__